import { useState } from "react";
import { catalog } from "@/mocks/catalog";
import type { CatalogItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

const allMovies = (catalog as CatalogItem[]).filter((it) => it.featuredMovie);
const tabs = ["全部", "剧情", "悬疑", "科幻", "温情", "文艺"];

export default function MoviesSection() {
  const [tab, setTab] = useState("全部");

  const list = allMovies.filter((it) => tab === "全部" || it.genres.includes(tab));

  return (
    <section id="movies" className="scroll-mt-20 border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="电影推荐"
          title="口碑在线的电影，一部一部讲给你听"
          desc="电影部分按题材分组，每部都写清了它适合什么心情、看点在哪儿。选片时可以按类型筛选，再结合时长决定今晚是看一部短片还是一部长片。"
        />

        <div className="mb-8 flex flex-wrap gap-2">
          {tabs.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setTab(t)}
              aria-pressed={tab === t}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
                tab === t
                  ? "bg-accent-500 text-background-50"
                  : "border border-background-300/60 bg-background-50 text-foreground-600 hover:border-accent-300 hover:text-accent-700"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-1 gap-4 md:gap-5 lg:grid-cols-2">
            {list.map((item) => (
              <article
                key={item.id}
                className="flex gap-4 overflow-hidden rounded-lg border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-accent-300"
              >
                <div className="relative h-40 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={item.poster}
                    alt={`${item.title} 海报`}
                    title={`${item.title} 电影推荐`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex flex-wrap items-center gap-2">
                    <h3 className="font-heading text-lg font-semibold text-foreground-950">{item.title}</h3>
                    <span className="flex items-center gap-1 rounded-md bg-accent-100 px-2 py-0.5 text-xs font-semibold text-accent-800">
                      <i className="ri-star-fill text-[10px]"></i>
                      {item.rating.toFixed(1)}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-foreground-600">
                    {item.year} · {item.region} · {item.genres.join(" / ")} · {item.duration}
                  </p>
                  <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-700">{item.summary}</p>
                  <div className="mt-auto flex flex-wrap items-center gap-2 pt-3">
                    <span className="rounded-md bg-foreground-950/80 px-2 py-0.5 text-xs text-background-50">
                      {item.quality}
                    </span>
                    {item.tags.map((tag) => (
                      <span
                        key={tag}
                        className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-12 text-center">
            <i className="ri-emotion-line text-3xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">这个题材暂时没有推荐，换个类型看看。</p>
          </div>
        )}
      </div>
    </section>
  );
}